<template>
  <div class="app-loader">
    <div class="preloader__cube bounce">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="250"
        height="30"
        viewBox="0 0 170 50"
        fill="none"
      >
        <path d="M137.724 15.1813L150.582 30.345H142.614L129.668 15.2165L142.614 0.0175781H150.582L137.724 15.1813Z" fill="#FE0190"/>
<path d="M6.68393 24.7334H12.9809C19.7352 24.7334 21.7755 19.5616 21.7755 15.111C21.7755 9.95673 19.3482 5.50609 12.9809 5.50609H6.68393V24.7334ZM13.7196 0C23.5345 0 28.5474 6.84304 28.5474 15.1989C28.5474 23.9946 23.6752 30.3274 13.0161 30.3274H0V0H13.7196Z" fill="#FE0190"/>
<path d="M46.2949 27.3897C46.5511 30.6305 45.5987 33.8514 43.6213 36.4316C42.2142 38.1908 40.1034 39 36.5856 39H34.8267V33.0716C35.1433 33.0716 35.5478 33.1597 35.8468 33.1597C38.45 33.1597 39.6285 30.9432 39.6285 27.5657V0H46.2949V27.3897Z" fill="#FE0190"/>
<path d="M70.832 6.24487C65.7311 6.24487 62.354 9.92155 62.354 15.3573C62.354 20.793 65.7311 24.4695 70.832 24.4695C75.9329 24.4695 79.31 20.9513 79.31 15.3573C79.31 9.76323 75.9329 6.24487 70.832 6.24487ZM70.832 30.7672C67.7901 30.7811 64.8124 29.8921 62.2758 28.2127C59.7393 26.5334 57.7579 24.1392 56.5826 21.3331C55.4072 18.527 55.0907 15.4352 55.673 12.4492C56.2554 9.46311 57.7104 6.71701 59.854 4.55838C61.9977 2.39974 64.7334 0.925662 67.7151 0.322729C70.6967 -0.280204 73.7902 0.0150773 76.604 1.17126C79.4177 2.32745 81.8252 4.29255 83.5218 6.81779C85.2184 9.34303 86.1277 12.3149 86.1347 15.3573C86.1848 17.3857 85.8241 19.4033 85.0742 21.2886C84.3242 23.174 83.2006 24.888 81.771 26.3277C80.3413 27.7673 78.6352 28.9029 76.7553 29.6659C74.8754 30.4288 72.8605 30.8034 70.832 30.7672Z" fill="#FE0190"/>
<path d="M108.825 6.24487C103.724 6.24487 100.347 9.92155 100.347 15.3573C100.347 20.793 103.724 24.4695 108.825 24.4695C113.926 24.4695 117.303 20.9513 117.303 15.3573C117.303 9.76323 113.926 6.24487 108.825 6.24487ZM108.825 30.7672C105.783 30.7811 102.805 29.8921 100.269 28.2127C97.7322 26.5334 95.7508 24.1392 94.5755 21.3331C93.4001 18.527 93.0836 15.4352 93.6659 12.4492C94.2483 9.46311 95.7034 6.71701 97.847 4.55838C99.9906 2.39974 102.726 0.925662 105.708 0.322729C108.69 -0.280204 111.783 0.0150773 114.597 1.17126C117.411 2.32745 119.818 4.29255 121.515 6.81779C123.211 9.34303 124.121 12.3149 124.128 15.3573C124.178 17.3857 123.817 19.4033 123.067 21.2886C122.317 23.174 121.194 24.888 119.764 26.3277C118.334 27.7673 116.628 28.9029 114.748 29.6659C112.868 30.4288 110.853 30.8034 108.825 30.7672Z" fill="#FE0190"/>
<path d="M166.957 16.1136L156.369 0.0175781H164.46L170.264 9.53448L176.139 0.0175781H184.16L173.641 16.1136V30.345H166.957V16.1136Z" fill="#FE0190"/>
        <!-- <path
          d="M47.6528 1.56401L47.408 2L47.408 2L47.6528 1.56401ZM47.408 1.42659L47.6528 0.990603L47.408 0.853189L47.1633 0.990603L47.408 1.42659ZM94.0609 27.6176L94.4968 27.8624L94.7416 27.4264L94.3056 27.1817L94.0609 27.6176ZM93.5713 28.4896L93.3266 28.9256L93.7626 29.1704L94.0073 28.7344L93.5713 28.4896ZM47.408 2.5734L47.6528 2.13741L47.408 2L47.1633 2.13741L47.408 2.5734ZM1.24477 28.4896L0.808776 28.7344L1.05354 29.1704L1.48953 28.9256L1.24477 28.4896ZM0.755233 27.6176L0.510465 27.1817L0.0744731 27.4264L0.319241 27.8624L0.755233 27.6176ZM47.1633 1.56401L47.408 2L47.4081 2L47.1633 1.56401ZM93.3161 28.0536V27.5536H92.8161V28.0536H93.3161ZM93.3161 79.8682L93.5609 80.3042L93.8161 80.1609V79.8682H93.3161ZM94.3161 28.0536H94.8161V27.5536H94.3161V28.0536ZM94.3161 80.4536L94.5609 80.8896L94.8161 80.7463V80.4536H94.3161ZM94.0609 80.5969L93.8161 80.1609L94.0609 80.5969ZM47.6528 106.651L47.2168 106.895L47.4616 107.331L47.8976 107.087L47.6528 106.651ZM47.1633 105.779L46.9185 105.343L46.4825 105.587L46.7273 106.023L47.1633 105.779ZM93.5713 27.6176L94.0073 27.3729L93.7626 26.9369L93.3266 27.1817L93.5713 27.6176ZM47.1633 53.6713L46.9185 53.2353L46.4825 53.4801L46.7273 53.9161L47.1633 53.6713ZM94.0609 28.4896L94.3056 28.9256L94.7416 28.6809L94.4968 28.2449L94.0609 28.4896ZM47.6528 54.5433L47.2168 54.788L47.4616 55.224L47.8976 54.9793L47.6528 54.5433ZM1.5 79.8682H1V80.1609L1.25523 80.3042L1.5 79.8682ZM1.5 28.0536H2V27.5536H1.5V28.0536ZM0.5 28.0536V27.5536H0V28.0536H0.5ZM0.5 80.4536H0V80.7463L0.255234 80.8896L0.5 80.4536ZM0.755233 80.5969L1 80.1609H0.999999L0.755233 80.5969ZM47.1633 106.651L46.9185 107.087L47.3545 107.331L47.5993 106.895L47.1633 106.651ZM47.6528 105.779L48.0888 106.023L48.3336 105.587L47.8976 105.343L47.6528 105.779ZM47.908 106.215V106.715H48.408V106.215H47.908ZM47.908 54.1073H48.408V53.6073H47.908V54.1073ZM46.908 106.215H46.408V106.715H46.908V106.215ZM46.908 54.1073V53.6073H46.408V54.1073H46.908ZM0.755233 28.4896L0.319241 28.2449L0.0744731 28.6809L0.510465 28.9256L0.755233 28.4896ZM47.1633 54.5433L46.9185 54.9793L47.3545 55.224L47.5993 54.788L47.1633 54.5433ZM1.24477 27.6176L1.48953 27.1817L1.05354 26.9369L0.808776 27.3729L1.24477 27.6176ZM47.6528 53.6713L48.0888 53.9161L48.3336 53.4801L47.8976 53.2353L47.6528 53.6713ZM47.8976 1.12802L47.6528 0.990603L47.1633 1.86259L47.408 2L47.8976 1.12802ZM94.3056 27.1817L47.8976 1.12802L47.408 2L93.8161 28.0536L94.3056 27.1817ZM94.0073 28.7344L94.4968 27.8624L93.6249 27.3729L93.1353 28.2449L94.0073 28.7344ZM47.1633 3.0094L93.3266 28.9256L93.8161 28.0536L47.6528 2.13741L47.1633 3.0094ZM1.48953 28.9256L47.6528 3.0094L47.1633 2.13741L1 28.0536L1.48953 28.9256ZM0.319241 27.8624L0.808776 28.7344L1.68076 28.2449L1.19122 27.3729L0.319241 27.8624ZM46.9185 1.12802L0.510465 27.1817L1 28.0536L47.408 2L46.9185 1.12802ZM47.1633 0.990603L46.9185 1.12802L47.4081 2L47.6528 1.86259L47.1633 0.990603ZM92.8161 28.0536V79.8682H93.8161V28.0536H92.8161ZM94.3161 27.5536H93.3161V28.5536H94.3161V27.5536ZM94.8161 80.1609V28.0536H93.8161V80.1609H94.8161ZM94.8161 80.4536V80.1609H93.8161V80.4536H94.8161ZM94.3056 81.0329L94.5609 80.8896L94.0713 80.0176L93.8161 80.1609L94.3056 81.0329ZM47.8976 107.087L94.3056 81.0329L93.8161 80.1609L47.408 106.215L47.8976 107.087ZM46.7273 106.023L47.2168 106.895L48.0888 106.406L47.5993 105.534L46.7273 106.023ZM93.0713 79.4322L46.9185 105.343L47.408 106.215L93.5609 80.3042L93.0713 79.4322ZM93.3266 27.1817L46.9185 53.2353L47.408 54.1073L93.8161 28.0536L93.3266 27.1817ZM94.4968 28.2449L94.0073 27.3729L93.1353 27.8624L93.6249 28.7344L94.4968 28.2449ZM47.8976 54.9793L94.3056 28.9256L93.8161 28.0536L47.408 54.1073L47.8976 54.9793ZM46.7273 53.9161L47.2168 54.788L48.0888 54.2985L47.5993 53.4265L46.7273 53.9161ZM2 79.8682V28.0536H1V79.8682H2ZM1.5 27.5536H0.5V28.5536H1.5V27.5536ZM0 28.0536V80.1609H1V28.0536H0ZM0 80.1609V80.4536H1V80.1609H0ZM0.255234 80.8896L0.510466 81.0329L0.999999 80.1609L0.744766 80.0176L0.255234 80.8896ZM0.510465 81.0329L46.9185 107.087L47.408 106.215L1 80.1609L0.510465 81.0329ZM47.5993 106.895L48.0888 106.023L47.2168 105.534L46.7273 106.406L47.5993 106.895ZM47.8976 105.343L1.74477 79.4322L1.25523 80.3042L47.408 106.215L47.8976 105.343ZM48.408 106.215V54.1073H47.408V106.215H48.408ZM46.908 106.715H47.908V105.715H46.908V106.715ZM46.408 54.1073V106.215H47.408V54.1073H46.408ZM47.908 53.6073H46.908V54.6073H47.908V53.6073ZM0.510465 28.9256L46.9185 54.9793L47.408 54.1073L1 28.0536L0.510465 28.9256ZM0.808776 27.3729L0.319241 28.2449L1.19122 28.7344L1.68076 27.8624L0.808776 27.3729ZM47.8976 53.2353L1.48953 27.1817L1 28.0536L47.408 54.1073L47.8976 53.2353ZM47.5993 54.788L48.0888 53.9161L47.2168 53.4265L46.7273 54.2985L47.5993 54.788Z"
          fill="black"
        /> -->
      </svg>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "App-Loader",
  });
</script>

<style lang="scss">
  .app-loader {
    display: flex;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(209, 209, 209, 0.479);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .section-loader {
    justify-content: center;
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(209, 209, 209, 0.479);
    & > div {
      position: fixed;
      top: 50%;
    }
  }

  .card-loader {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 500px;
  }

  .scroll-loader {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 150px 0;
    &.loader--transparent {
      opacity: 0.5;
    }
  }

  .preloader__text {
    position: relative;
    z-index: 100;
  }

  .bounce {
    animation-name: bounce-3;
    animation-duration: 1.5s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }

  @keyframes bounce-3 {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-3vh);
    }

    100% {
      transform: translateY(0);
    }
  }
  .preloader {
    display: block !important;
    &__text {
      text-align: center;
    }
  }
</style>
